import { render, staticRenderFns } from "./FastsIndex.vue?vue&type=template&id=4c1cff88&scoped=true&"
import script from "./FastsIndex.vue?vue&type=script&lang=js&"
export * from "./FastsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1cff88",
  null
  
)

export default component.exports